import { ProjectStatusFragment } from '@/gql/generated/graphql'
import { LiveCountdownTimer } from '@components/live-countdown-timer'
import { UpcomingReleaseDate } from '@components/upcoming-release-date'
import { getProjectStatus, ValidStatusType } from '@utils/project'

export const ReleaseTimer = ({ project }: { project?: ProjectStatusFragment }): React.ReactElement | null => {
  if (!project) {
    return null
  }
  const status = getProjectStatus(project)

  const startTime = project?.auction_start_time ?? project.start_datetime
  if (status === ValidStatusType.live) {
    return <LiveCountdownTimer project={project} dark showSeconds={false} />
  }
  if (status === ValidStatusType.upcoming && startTime) {
    return <UpcomingReleaseDate startTime={startTime} dark releasingText={false} />
  }

  return null
}

export const TimerText = ({ project }: { project?: ProjectStatusFragment }): React.ReactElement | null => {
  if (!project) {
    return null
  }
  const status = getProjectStatus(project)

  const startTime = project?.auction_start_time ?? project.start_datetime
  if (status === ValidStatusType.live) {
    return <LiveCountdownTimer project={project} dark showSeconds={false} />
  }
  if (status === ValidStatusType.upcoming && startTime) {
    return <UpcomingReleaseDate startTime={startTime} dark releasingText={false} />
  }

  return null
}
